import { render } from "./B2bTableMenuRecadvsEmit.vue?vue&type=template&id=53777b50&scoped=true&lang=pug"
import script from "./B2bTableMenuRecadvsEmit.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuRecadvsEmit.vue?vue&type=script&lang=js"

import "./B2bTableMenuRecadvsEmit.vue?vue&type=style&index=0&id=53777b50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53777b50"]])

export default __exports__